













































import { Component, Vue } from 'vue-property-decorator';
import { DeliveryNote, PaginationSync, PaginationItem } from '../customTypes';
import DeliveryNoteService from '../services/deliveryNote';
import VueQr from 'vue-qr';
@Component({
  components: { VueQr },
})
export default class DeliveryNotesQr extends Vue {
  public deliveryNotes: DeliveryNote[] = [];
  public loadingQrs: boolean = false;
  public search: string = '';
  public paginationSync: PaginationSync = {
    descending: true,
    sortBy: '',
  } as PaginationSync;
  public rowsPerPageItems: PaginationItem[] = [
    { text: '12', value: 12 },
    { text: '24', value: 24 },
    { text: '48', value: 48 },
    { text: '96', value: 96 },
    { text: 'All', value: -1 },
  ];

  private deliveryNoteService: DeliveryNoteService;

  constructor() {
    super();
    this.deliveryNoteService = new DeliveryNoteService();
  }


  public async created() {
    await this.loadDeliveryNotes();
  }

  public async loadDeliveryNotes() {
    this.loadingQrs = true;
    this.deliveryNotes = await this.deliveryNoteService.getLastDeliveryNotes();
    this.loadingQrs = false;
  }
}
